module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bonus-container"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('ul', {
    staticClass: "text-list"
  }, _vm._l((_vm.articles), function(article) {
    return _c('li', {
      style: ({
        background: article.bg,
        backgroundSize: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#ffffff'
      })
    }, [_c('div', {
      staticClass: "content"
    }, [_vm._m(2, true), _vm._v(" "), _c('div', {
      staticClass: "bonus-text"
    }, [_c('div', {
      staticClass: "bonus-text-title"
    }, [_vm._v(_vm._s(article.title))]), _vm._v(" "), _c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "bonus-text-content"
    }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(article.content_1)), _c('br'), _vm._v("\n\t\t\t\t\t\t" + _vm._s(article.content_2)), _c('br'), _vm._v("\n\t\t\t\t\t\t" + _vm._s(article.content_3)), _c('br'), _vm._v("\n\t\t\t\t\t\t" + _vm._s(article.content_4)), _c('br'), _vm._v("\n\t\t\t\t\t\t" + _vm._s(article.content_5)), _c('br'), _vm._v("\n\t\t\t\t\t\t" + _vm._s(article.content_6)), _c('br')])]), _vm._v(" "), _c('div', {
      staticClass: "author"
    })])])
  }))])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bonus-header"
  }, [_c('span', {
    staticClass: "yellow"
  }, [_vm._v("  简书2015")]), _vm._v(" "), _c('i', [_vm._v(" · ")]), _vm._v(" "), _c('span', [_vm._v("每月一篇好文章  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "share"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-mobile"
  }), _vm._v("手机查看效果更佳")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-weibo"
  }), _vm._v("分享到微博")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-wechat"
  }), _vm._v("分享到微信")])]), _vm._v(" "), _c('span', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("更多分享")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "mask",
    attrs: {
      "href": "#"
    }
  }, [_c('div', {
    staticClass: "button"
  }, [_vm._v("阅读全文>")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-361798ec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bonus.vue
// module id = 61
// module chunks = 0